import React from "react";
import { Navigate, useParams } from "react-router-dom";

export default function Link() {
  const { id } = useParams();
  return <Navigate to={`/register?af=${id}`} />;
}
